import React from "react";
import { Row, Col, Input } from "reactstrap";

const ProjectFilters = ({ filters, setFilters, onAdd }) => {
  const handleChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <div className="card p-3 mb-3 shadow-sm">
      <Row className="gy-2">
        <Col md={3}>
          <Input
            type="text"
            placeholder="Search Projects"
            value={filters.search}
            onChange={(e) => handleChange("search", e.target.value)}
          />
        </Col>

        <Col md={2}>
          <Input
            type="select"
            value={filters.projectType}
            onChange={(e) => handleChange("projectType", e.target.value)}
          >
            <option value="">All Types</option>

            <optgroup label="Residential">
              <option value="Apartments">Apartments</option>
              <option value="Floors">Floors</option>
              <option value="Farm House">Farm House</option>
              <option value="Villas">Villas</option>
              <option value="Studio Apartments">Studio Apartments</option>
            </optgroup>

            <optgroup label="Commercial">
              <option value="Office Spaces">Office Spaces</option>
              <option value="SCO Plots">SCO Plots</option>
              <option value="Retail Shops">Retail Shops</option>
            </optgroup>

            <optgroup label="Plots">
              <option value="Land Parcel Plots">Land Parcel Plots</option>
              <option value="Villa Plots">Villa Plots</option>
              <option value="Agricultural Plots">Agricultural Plots</option>
            </optgroup>
          </Input>
        </Col>

        <Col md={2}>
          <Input
            type="select"
            value={filters.projectStatus}
            onChange={(e) => handleChange("projectStatus", e.target.value)}
          >
            <option value="">All Status</option>
            <option value="Upcoming">Upcoming</option>
            <option value="Under Construction">Under Construction</option>
            <option value="Ready to Move">Ready to Move</option>
            <option value="Delivered">Delivered</option>
          </Input>
        </Col>

        <Col md={4} sm={6} className="gx-2 d-flex justify-content-evenly">
          <button
            className="btn btn-outline-primary "
            onClick={() =>
              setFilters({
                search: "",
                projectType: "",
                projectStatus: "",
              })
            }
          >
            Reset
          </button>
          <button
            className="btn btn-primary "
            onClick={onAdd}
          >
            + Add
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default ProjectFilters;